export const LayoutConstants = {
  LOGOUT: 'logout',
  LOGO_URL: 'https://www.borrowersviewcentral.com',
  PROFILE: 'profile',
  PROFILE_TITLE: 'Manage Your Profile',
  LOGOUT_TITLE: 'Logout',
};
